// extracted by mini-css-extract-plugin
export default {"oosPopoverWrapper":"Eo-z","slideIn":"Fo-z"};